var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallingAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.32,264.64c86.34,48.85,86.79,128,1,176.89s-225.3,48.84-311.64,0-86.8-128-1-176.89S319,215.79,405.32,264.64Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.94,50.4c-4.67,2.7-8.71,8.13-10.65,13.77a8.42,8.42,0,0,0-3.48,1.2l-.75.46a20.37,20.37,0,0,0-8,12.85,11.84,11.84,0,0,0,0,4,.7.7,0,0,1-.32.65L94.9,86.1a8.41,8.41,0,0,0-3.8,6.58c0,2.42,1.72,3.4,3.83,2.18l47.12-27.21a8.34,8.34,0,0,0,3.8-6.58c0-2.42-1.72-3.39-3.82-2.17l-7.72,4.45c-.24.14-.4,0-.31-.34a19.32,19.32,0,0,0,.86-6.95c-.51-6.38-5.23-9-11-6.13C123.53,50.07,123.23,50.23,122.94,50.4Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.11,44.4a18.08,18.08,0,0,0-7.35,9.51,5.81,5.81,0,0,0-2.4.82,5.69,5.69,0,0,0-.52.33,14,14,0,0,0-5.53,8.87,8.18,8.18,0,0,0,0,2.75.48.48,0,0,1-.22.45l-3.33,1.92a5.8,5.8,0,0,0-2.62,4.54c0,1.67,1.19,2.34,2.64,1.5L99.3,56.31a5.8,5.8,0,0,0,2.62-4.54c0-1.67-1.19-2.34-2.64-1.5L94,53.34c-.17.1-.28,0-.22-.23a13.29,13.29,0,0,0,.59-4.8c-.35-4.4-3.61-6.21-7.62-4.23Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.27,377.08l13.87,8.3a6.79,6.79,0,0,0,7,0l112.77-67.53a2.41,2.41,0,0,0,0-4.11L227,305.44a6.79,6.79,0,0,0-7,0L107.27,373A2.41,2.41,0,0,0,107.27,377.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.76,356.76c23.3,13.46,23.43,35.27.28,48.72s-60.81,13.46-84.11,0-23.43-35.26-.28-48.72S346.46,343.31,369.76,356.76Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.18,303.48c-2.57-2.46-5.52-5.15-5.7-8.71a7.82,7.82,0,0,1,5.12-7.29,11.85,11.85,0,0,1,9.23.7,25.27,25.27,0,0,1,7.39,5.91,59.2,59.2,0,0,1,13.94,51.72c-.26,1.2-.66,2.53-1.74,3.1-1.72.91-3.68-.69-4.86-2.24a35.84,35.84,0,0,1-5.71-11.3c-1-3.45-.56-7.25-1.86-10.5C105.81,316.9,99.3,309.33,93.18,303.48Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,303.48c-2.57-2.46-5.52-5.15-5.7-8.71a7.82,7.82,0,0,1,5.12-7.29,11.85,11.85,0,0,1,9.23.7,25.27,25.27,0,0,1,7.39,5.91,59.2,59.2,0,0,1,13.94,51.72c-.26,1.2-.66,2.53-1.74,3.1-1.72.91-3.68-.69-4.86-2.24a35.84,35.84,0,0,1-5.71-11.3c-1-3.45-.56-7.25-1.86-10.5C105.81,316.9,99.3,309.33,93.18,303.48Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,344.26h0a.68.68,0,0,1-.68-.69,67.27,67.27,0,0,0-25.18-51.91.7.7,0,0,1-.12-1,.71.71,0,0,1,1-.11,68.63,68.63,0,0,1,25.7,53A.69.69,0,0,1,119.92,344.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,371.54c-4.33,1.39-9.76.48-12.27-3.32-3-4.46-1.11-11.34-5.06-15-2.21-2-5.46-2.22-8.39-2.82s-6.18-2.23-6.62-5.19c-.58-3.92,4.24-7.18,3.57-11.09s-6-5.06-7.57-8.64c-1.43-3.26,1.1-7.21,4.46-8.43s7.09-.38,10.43.86,6.59,2.88,10.13,3.32,7.94-.27,10.64,2.26c3.62,3.38,1.55,9.83,4.34,13.91,1.88,2.74,5.41,3.69,8.11,5.61a13,13,0,0,1,5.36,10.65c-.09,4.49-2.45,7.74-5.85,10.32C119.17,366.78,116,370.1,111.49,371.54Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,371.54c-4.33,1.39-9.76.48-12.27-3.32-3-4.46-1.11-11.34-5.06-15-2.21-2-5.46-2.22-8.39-2.82s-6.18-2.23-6.62-5.19c-.58-3.92,4.24-7.18,3.57-11.09s-6-5.06-7.57-8.64c-1.43-3.26,1.1-7.21,4.46-8.43s7.09-.38,10.43.86,6.59,2.88,10.13,3.32,7.94-.27,10.64,2.26c3.62,3.38,1.55,9.83,4.34,13.91,1.88,2.74,5.41,3.69,8.11,5.61a13,13,0,0,1,5.36,10.65c-.09,4.49-2.45,7.74-5.85,10.32C119.17,366.78,116,370.1,111.49,371.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.54,340.83l-.05-.07c-.65-.94-1.32-1.87-2-2.76a49.82,49.82,0,0,0-24.9-16.56.69.69,0,1,0-.38,1.32,48.42,48.42,0,0,1,24.21,16.1c.19.24.36.51.55.75-7.76-2.85-15.68-1.23-19.9,2.17a.68.68,0,0,0-.1,1,.68.68,0,0,0,1,.11c4.18-3.37,12.81-4.87,20.63-1.08A48.39,48.39,0,0,1,116.84,366a.68.68,0,0,0,.68.64h0a.68.68,0,0,0,.65-.72A49.8,49.8,0,0,0,109.54,340.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,325.4c2.09-2,4.48-4.18,4.62-7.06a6.32,6.32,0,0,0-4.15-5.91,9.56,9.56,0,0,0-7.49.57,20.21,20.21,0,0,0-6,4.79,48,48,0,0,0-11.32,42,3.55,3.55,0,0,0,1.42,2.52c1.4.74,3-.56,3.94-1.82a28.88,28.88,0,0,0,4.63-9.18c.84-2.79.46-5.88,1.51-8.51C364.46,336.3,369.74,330.15,374.71,325.4Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,358.49h0a.56.56,0,0,0,.56-.56A54.56,54.56,0,0,1,374,315.81a.56.56,0,0,0-.69-.87,55.7,55.7,0,0,0-20.85,43A.56.56,0,0,0,353,358.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.85,380.62c3.52,1.13,7.93.39,10-2.69,2.39-3.62.9-9.2,4.1-12.13,1.8-1.63,4.43-1.8,6.81-2.29s5-1.8,5.37-4.2c.47-3.19-3.44-5.83-2.89-9s4.86-4.1,6.14-7c1.16-2.65-.9-5.86-3.62-6.84s-5.75-.31-8.46.69-5.35,2.34-8.22,2.69-6.44-.22-8.63,1.84c-2.94,2.74-1.26,8-3.53,11.29-1.52,2.22-4.38,3-6.57,4.54a10.53,10.53,0,0,0-4.35,8.65c.07,3.64,2,6.27,4.74,8.37C353.63,376.76,356.24,379.46,359.85,380.62Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.85,380.62c3.52,1.13,7.93.39,10-2.69,2.39-3.62.9-9.2,4.1-12.13,1.8-1.63,4.43-1.8,6.81-2.29s5-1.8,5.37-4.2c.47-3.19-3.44-5.83-2.89-9s4.86-4.1,6.14-7c1.16-2.65-.9-5.86-3.62-6.84s-5.75-.31-8.46.69-5.35,2.34-8.22,2.69-6.44-.22-8.63,1.84c-2.94,2.74-1.26,8-3.53,11.29-1.52,2.22-4.38,3-6.57,4.54a10.53,10.53,0,0,0-4.35,8.65c.07,3.64,2,6.27,4.74,8.37C353.63,376.76,356.24,379.46,359.85,380.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,355.71l0-.06c.53-.76,1.07-1.51,1.65-2.23A40.31,40.31,0,0,1,383.33,340a.56.56,0,0,1,.69.38.56.56,0,0,1-.39.69A39.19,39.19,0,0,0,364,354.11c-.16.2-.3.41-.45.61,6.29-2.32,12.71-1,16.14,1.76a.56.56,0,0,1-.35,1,.53.53,0,0,1-.35-.13c-3.39-2.73-10.39-3.94-16.74-.87a39.33,39.33,0,0,0-6.73,19.65.56.56,0,0,1-.56.52h0a.55.55,0,0,1-.52-.59A40.32,40.32,0,0,1,361.44,355.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281,109.16c.46-.27.83,0,.83.48l0,5.61a1.82,1.82,0,0,1-.83,1.43c-.46.27-.83,0-.83-.47l0-5.61A1.84,1.84,0,0,1,281,109.16Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.33,119.82a.57.57,0,0,1,.64,0l3.15,2.48c.3.24.25.87-.1,1.41a1.57,1.57,0,0,1-.53.53.56.56,0,0,1-.64,0l-3.15-2.48c-.3-.24-.26-.87.1-1.41A1.61,1.61,0,0,1,270.33,119.82Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,127.06A.73.73,0,0,1,267,127l4.24.37c.4,0,.54.54.31,1.13a1.87,1.87,0,0,1-.72.89.7.7,0,0,1-.42.11l-4.24-.36c-.39,0-.53-.54-.3-1.13A1.79,1.79,0,0,1,266.63,127.06Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,141c.29-.17.57-.16.72.06a1.39,1.39,0,0,1-.3,1.48l-4.22,5.25a1.49,1.49,0,0,1-.41.36c-.29.17-.57.16-.73-.06a1.41,1.41,0,0,1,.3-1.48l4.22-5.25A1.52,1.52,0,0,1,270.9,141Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.49,137.35c.4-.22.75-.1.82.32a1.77,1.77,0,0,1-.67,1.5l-4.81,3.75-.14.1c-.4.23-.75.11-.82-.32a1.74,1.74,0,0,1,.67-1.5l4.8-3.75Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.75,107.46a.64.64,0,0,1,.54-.09c.35.14.4.71.11,1.29l-3.13,6.11a1.72,1.72,0,0,1-.64.71.68.68,0,0,1-.54.09c-.35-.14-.4-.72-.1-1.3l3.12-6.1A1.66,1.66,0,0,1,291.75,107.46Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.73,107a.84.84,0,0,1,.29-.1c.43-.07.65.35.5.94l-1.66,6.23a1.82,1.82,0,0,1-.78,1.08.82.82,0,0,1-.28.11c-.43.07-.66-.35-.5-.94l1.65-6.23A1.87,1.87,0,0,1,286.73,107Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281,109.16c.46-.27.83,0,.83.48l0,5.61a1.82,1.82,0,0,1-.83,1.43c-.46.27-.83,0-.83-.47l0-5.61A1.84,1.84,0,0,1,281,109.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.33,119.82a.57.57,0,0,1,.64,0l3.15,2.48c.3.24.25.87-.1,1.41a1.57,1.57,0,0,1-.53.53.56.56,0,0,1-.64,0l-3.15-2.48c-.3-.24-.26-.87.1-1.41A1.61,1.61,0,0,1,270.33,119.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.63,127.06A.73.73,0,0,1,267,127l4.24.37c.4,0,.54.54.31,1.13a1.87,1.87,0,0,1-.72.89.7.7,0,0,1-.42.11l-4.24-.36c-.39,0-.53-.54-.3-1.13A1.79,1.79,0,0,1,266.63,127.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,141c.29-.17.57-.16.72.06a1.39,1.39,0,0,1-.3,1.48l-4.22,5.25a1.49,1.49,0,0,1-.41.36c-.29.17-.57.16-.73-.06a1.41,1.41,0,0,1,.3-1.48l4.22-5.25A1.52,1.52,0,0,1,270.9,141Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.49,137.35c.4-.22.75-.1.82.32a1.77,1.77,0,0,1-.67,1.5l-4.81,3.75-.14.1c-.4.23-.75.11-.82-.32a1.74,1.74,0,0,1,.67-1.5l4.8-3.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.75,107.46a.64.64,0,0,1,.54-.09c.35.14.4.71.11,1.29l-3.13,6.11a1.72,1.72,0,0,1-.64.71.68.68,0,0,1-.54.09c-.35-.14-.4-.72-.1-1.3l3.12-6.1A1.66,1.66,0,0,1,291.75,107.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.73,107a.84.84,0,0,1,.29-.1c.43-.07.65.35.5.94l-1.66,6.23a1.82,1.82,0,0,1-.78,1.08.82.82,0,0,1-.28.11c-.43.07-.66-.35-.5-.94l1.65-6.23A1.87,1.87,0,0,1,286.73,107Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M283.64,388.62a12.53,12.53,0,0,0,9.53,3.59,28.31,28.31,0,0,0,10.07-2.61c3.23-1.36,7.27-5.16,10.76-5.09a82.41,82.41,0,0,0,10.19-.71,55.73,55.73,0,0,0-1.45-14.15l-16.27-.44c-4.39,6.17-12.93,11.3-19.39,13.22a5.78,5.78,0,0,0-4,4.38.41.41,0,0,0,0,.11A7.3,7.3,0,0,0,283.64,388.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,384.51c-3.49-.07-7.53,3.73-10.76,5.09a28.31,28.31,0,0,1-10.07,2.61,12.53,12.53,0,0,1-9.53-3.59,7.3,7.3,0,0,1-.56-1.7.41.41,0,0,1,0-.11,5.36,5.36,0,0,0,0,2.22,7.3,7.3,0,0,0,.56,1.7,12.49,12.49,0,0,0,9.53,3.59,28.3,28.3,0,0,0,10.07-2.6c3.23-1.36,7.27-5.16,10.76-5.09a74.47,74.47,0,0,0,10-.6c.08-.74.13-1.49.16-2.23A82.41,82.41,0,0,1,314,384.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.75,389.65a24.52,24.52,0,0,1-.49,5.06,11.77,11.77,0,0,1-4.51,7.37,14.26,14.26,0,0,1-7.17,2,15.57,15.57,0,0,1-6.55-.7,7.45,7.45,0,0,1-3.84-3.21s0,.06,0,.09a7,7,0,0,0,4.42,4.71,15.45,15.45,0,0,0,6.56.69,14.14,14.14,0,0,0,7.16-1.95,11.71,11.71,0,0,0,4.51-7.38,24.43,24.43,0,0,0,.49-5.05,8.63,8.63,0,0,1,2.65-6.18,14.6,14.6,0,0,0,1.15-1.22,3,3,0,0,0,.71-2.21c0-.31-.06-.62-.1-.92-.59.72-2,2.42-2.36,2.76A8.66,8.66,0,0,0,356.75,389.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.31,372A19,19,0,0,1,343,382.29a39.76,39.76,0,0,1-5.29,8.92,26.74,26.74,0,0,0-2.78,4.14,7.65,7.65,0,0,0-.78,4.78,7.45,7.45,0,0,0,3.84,3.21,15.57,15.57,0,0,0,6.55.7,14.26,14.26,0,0,0,7.17-2,11.77,11.77,0,0,0,4.51-7.37,24.52,24.52,0,0,0,.49-5.06,8.66,8.66,0,0,1,2.64-6.18c.36-.34,1.77-2,2.36-2.76a18.89,18.89,0,0,0-2.43-7.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.66,223l1.23,86.06,4,60.24c10,6.5,17.3,1.19,17.3,1.19,3.81-28.54,4.32-46.09,2.25-58l1.9-46.44L333,314.3l9.6,59.11c10.29,6.84,17.56,0,17.56,0,0-21.88,1.9-46.34-4-62.12,4.15-48.75-2.77-87.39-2.77-87.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,248.35l2.1,17.74-.89,21.75-3.86-35.76c-9-3.59-10.12-8.64-10.12-8.64A27,27,0,0,0,325.2,248.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,123.53l-2.29-1.2-.05,0-.09,0h0a1.29,1.29,0,0,0-1.19.06l-20.49,11.83a2.64,2.64,0,0,0-1.32,2.29v9.92a1.28,1.28,0,0,0,.54,1.06h0l0,0a1.19,1.19,0,0,0,.25.13l2.22,1.18-.11-1.81,19.53-11.27a2.65,2.65,0,0,0,1.33-2.29v-8.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.62,136.89l-20.49,11.83a1.33,1.33,0,0,1-2-1.14v-9.93a2.67,2.67,0,0,1,1.32-2.29L307,123.53a1.32,1.32,0,0,1,2,1.15v9.92A2.63,2.63,0,0,1,307.62,136.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.46,137.65a1.33,1.33,0,0,1,.66-1.14l20.5-11.83v9.92a1.33,1.33,0,0,1-.66,1.15l-20.49,11.82Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.71,152.32a3.55,3.55,0,0,1,1.33-1.59,9.24,9.24,0,0,0,3.77-4.65,25.67,25.67,0,0,0,.94-6.31,9.83,9.83,0,0,1,2.16-5.89c-3.64-1.47-5.12,1.84-6.44,7.14l-12.19,7,.17.4a3,3,0,0,1,0,2.48l-3.55,7.21a12.4,12.4,0,0,0,12,1.35A61.08,61.08,0,0,1,298.71,152.32Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.25,166.92c.64-2.59,1.41-6,1.91-9a15.73,15.73,0,0,1-13.69-1.62,70.18,70.18,0,0,0-3.88,7.58A17.74,17.74,0,0,0,296.25,166.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.12,171.24s.5-1.78,1.13-4.32a17.74,17.74,0,0,1-15.66-3.07A80.57,80.57,0,0,0,274.28,189a21.48,21.48,0,0,0,.37,7.59,8.94,8.94,0,0,0,4.57,5.84c3.23,1.48,7.1.2,10-1.81,5.51-3.78,9-9.81,12.25-15.63l8.87-31.67C305.09,153.9,300.79,156.85,295.12,171.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.12,171.24c-2.08,7.36-5.33,19.11-5.33,19.11C297.19,182.83,295.12,171.24,295.12,171.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06,158a22.29,22.29,0,0,0-6.63,7.07c-2.9,5-3.75,10.82-4.54,16.52q-.84,6-1.67,12A88.35,88.35,0,0,0,301.5,185Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,152.35l-9.46,1c-7.75,6.83-11.75,21.16-10.08,37a207.34,207.34,0,0,1,.37,32.66c21,15.34,49.43,4.2,52.76.87l-2.69-19.45a13.59,13.59,0,0,1,1.06-6.39c2-4.61,5.52-13.67,6-20.69A36.72,36.72,0,0,0,354,159.26l-13.75-6Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.79,198c1.75-4.06,4.7-11.57,5.7-18.1-1.95,1.18-4,2.34-4.82,4.28A34.37,34.37,0,0,0,350.72,204,13.53,13.53,0,0,1,351.79,198Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,166.14c-7.92,18.21-7.79,37-7.79,37l3.89,8.37,6.11-8a314.94,314.94,0,0,1,.73-36.79Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.87,159.26a28.41,28.41,0,0,0,.34,6.88,5.46,5.46,0,0,0,2.94.54,23.91,23.91,0,0,0,4.72-5.71l-4.72-1.71Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.15,159.26c4.07,1.5,7.69,8.75,7.69,8.75,10.7-9.08,12.37-14.75,12.37-14.75-2.75-3.91-5.75-4.54-5.75-4.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.15,159.26c-3.11.09-5.86,4.42-5.86,4.42-.5-7.58,5.86-13.42,5.86-13.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71,140.23l-14.56,5.2v5.39a23.84,23.84,0,0,0,9.23-3.35A14.17,14.17,0,0,0,334.71,140.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.71,140.23a14.17,14.17,0,0,1-5.33,7.24,23.84,23.84,0,0,1-9.23,3.35v8.44s15.39-6.91,15.39-10.16v-9.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,118.88a8.79,8.79,0,0,1-8-4.5,1.21,1.21,0,0,1,1.31-1.74,9.54,9.54,0,0,0,3.37,0,16,16,0,0,1-3.14-11.9,1.51,1.51,0,0,1,2.15-1.13,29.57,29.57,0,0,0,14.95,3c2.75-.19,5.46-.78,8.21-1a15.22,15.22,0,0,1,8.07,1.23,7.67,7.67,0,0,1,4.4,6.5,3.79,3.79,0,0,1,2.73-1.58,4.21,4.21,0,0,1,3.18.94c-1.59.88-3.14,1.76-4.73,2.63,1.63-.58,3.68.69,4.49,2.22a10.94,10.94,0,0,1,.87,5.06,39.39,39.39,0,0,1-.31,6.87,13.19,13.19,0,0,1-2.6,6.3,10,10,0,0,1-4.74,3.21,12.92,12.92,0,0,1-7.68-.25,30.48,30.48,0,0,1-7-3.48A109.41,109.41,0,0,1,306.66,118.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,114.3a52.83,52.83,0,0,0,3,28.25c.82,2.07,1.9,4.21,3.83,5.32s4.54.91,6.85.56a34.68,34.68,0,0,0,10.82-3,14.75,14.75,0,0,0,7.49-8.07,6.48,6.48,0,0,0,6.56-2.57,12.27,12.27,0,0,0,2.13-7.17c0-1.62-.3-3.53-1.76-4.24s-3,.08-4.15,1a12.42,12.42,0,0,0-4,6.06c-1.07-3.94-2.74-7.75-3.81-11.7-.42-1.56-.94-3.25-2.3-4.12-1.65-1.06-3.81-.45-5.72,0A37.74,37.74,0,0,1,306.31,114.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.82 126.28 313.2 134.06 318.71 135.09 317.82 126.28",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,137.77l-4.19,2a2.75,2.75,0,0,0,3.18.91A2.49,2.49,0,0,0,324,137.77Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,137.77l-4.19,2a2.75,2.75,0,0,0,3.18.91A2.49,2.49,0,0,0,324,137.77Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.55,140.84a2.56,2.56,0,0,0,1.46-.13,2.24,2.24,0,0,0,1.11-2.21,2.64,2.64,0,0,0-1.64.57A2.67,2.67,0,0,0,321.55,140.84Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.8,126.59a1.58,1.58,0,1,1-3.15.32,1.57,1.57,0,0,1,1.41-1.73A1.59,1.59,0,0,1,325.8,126.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.54,127.42A1.58,1.58,0,1,1,310.8,126,1.59,1.59,0,0,1,312.54,127.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,121.31l-3.24,2.76a2.25,2.25,0,0,1,.43-2.53A2.66,2.66,0,0,1,310.37,121.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.83,119.76c1.24.69,2.48,1.38,3.73,2.06a2.26,2.26,0,0,0-.93-2.4A2.7,2.7,0,0,0,323.83,119.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,193.43l5-2.48a8.92,8.92,0,0,0,3.75-3.5l1.57-2.69a11,11,0,0,1,4.6-4.28,37.45,37.45,0,0,0,8-5.3h0a4.17,4.17,0,0,1-.64,5.22,30,30,0,0,1-3.28,2.61l2.41.61a8.57,8.57,0,0,0,5.25-.32l6.88-2.67a1.2,1.2,0,0,1,1.61,1.32,27.24,27.24,0,0,1-3.41,8.63,10.28,10.28,0,0,1-7,4.91c-3.51.66-6.91,1.18-8.84,1.45a10.7,10.7,0,0,0-3.18,1l-7.38,3.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,201.16a12.5,12.5,0,0,1-.88-6.54L371,199.1a197.3,197.3,0,0,1-4-20.88c-1.12-9.49-.87-15.87-13.08-19l-1.29,25s1.5,30.5,10.25,33.88c7.24,2.79,12.35-4.1,23.4-11.24A12.49,12.49,0,0,1,381.34,201.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.71,205.35c.33-1.42,2.66-4.67,6.33-6.25,0,0-.28-1.11-.69-2.91C368.45,197.13,363.77,200,364.71,205.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.92,190.6l-8.46,4a12.3,12.3,0,0,0,5.86,12.24,77.52,77.52,0,0,1,7.72-4.39S389.54,198.85,388.92,190.6Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.56,68.44a1.27,1.27,0,0,0-.65-1.11h0l-5.78-3.21h-.05a1.25,1.25,0,0,0-1.24,0L376.32,86.94a3.89,3.89,0,0,0-1.93,3.35l0,14.69-13.68,14.15c-1.22,1.27-1.35,3.18-.4,3.48l5.45,3a.85.85,0,0,0,.75.24l7.94-1,0,10.78a1.25,1.25,0,0,0,.63,1.1h0l5.74,3.19.08,0,.06,0a1.27,1.27,0,0,0,1.18-.05l39.52-22.82a3.84,3.84,0,0,0,1.93-3.35ZM381.2,90.89l-.13.15Zm-.37.48-.1.14Zm-.55,1.29a1,1,0,0,0,0,.17A1,1,0,0,1,380.28,92.66Zm1.21-2a1.49,1.49,0,0,1,.14-.12A1.49,1.49,0,0,0,381.49,90.61Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,82.66a1.49,1.49,0,0,0-.46.36,1.27,1.27,0,0,0-.23.41,20.43,20.43,0,0,0-1.1,2.68c-.33.81-.64,1.62-.92,2.44a2,2,0,0,0-.17.46,3,3,0,0,0-.22.61c-.18.46-.36.91-.53,1.37-.07.13-.13.25-.19.38a7.67,7.67,0,0,0-.44,1.18,1.08,1.08,0,0,0,.12,1.07,3.42,3.42,0,0,0,1.54.84l.15.05.48.13.83.41.16.1c.05.07.11.13.16.19a1,1,0,0,1,.13.24.9.9,0,0,1,0,.41c-.05.2-.1.41-.14.61s-.25.68-.37,1l-.18.44L408,99.5c-.21.47-.36.86-.51,1.25a7.26,7.26,0,0,0-.38.86l-.21.43c-.17.36-.35.72-.52,1.09l-.15.32-.56,1-.21.4-.65,1.14-.17.29L404,107.5l-.2.3-1.5,2.18-.6.81-.17.23-1.83,2.32L399,114a1.82,1.82,0,0,1-.47.4.71.71,0,0,1-.75,0l-.45-.23c0-.07-.06-.08-.11-.09a13.72,13.72,0,0,0-2-1.46.83.83,0,0,0-.89,0,1.5,1.5,0,0,0-.23.17,3.84,3.84,0,0,0-.77.87.4.4,0,0,0-.17.21c-.55.77-1.16,1.46-1.73,2.2s-1.05,1.23-1.56,1.87c-.29.33-.57.67-.84,1s-.61.75-.9,1.16a2.78,2.78,0,0,0-.31.43,1.5,1.5,0,0,0-.36,1.23,5,5,0,0,0,.07.8,3.48,3.48,0,0,0,.21,1,2.18,2.18,0,0,0,.18.61,1.62,1.62,0,0,0,.1.18.32.32,0,0,0,0,.14.91.91,0,0,0,.11.16.54.54,0,0,0,.29.33.91.91,0,0,0,.36.29l.25.1.17,0,.21.08.1,0a.82.82,0,0,0,.35,0,.17.17,0,0,0,.17,0,.93.93,0,0,0,.44,0,1.12,1.12,0,0,0,.48,0,1.59,1.59,0,0,0,.48,0l.29,0a3.2,3.2,0,0,0,.67-.14l.11,0,.24-.06a.41.41,0,0,0,.17-.07l.25-.09a4.73,4.73,0,0,0,.73-.28l.2-.1.16-.09a3.93,3.93,0,0,0,.41-.26,5.25,5.25,0,0,0,.47-.31,6.41,6.41,0,0,0,.52-.39q.22-.15.45-.33l.18-.16.09-.08.25-.21a9.8,9.8,0,0,0,.74-.71,4.4,4.4,0,0,0,.54-.52.5.5,0,0,0,.15-.17,9.69,9.69,0,0,0,1-1,9,9,0,0,0,.76-.75,5.14,5.14,0,0,0,.56-.58l.31-.32a.84.84,0,0,0,.23-.26.26.26,0,0,0,.11-.12l.17-.16a4,4,0,0,0,.26-.32,6.91,6.91,0,0,0,.51-.57l.16-.2.16-.2a12.19,12.19,0,0,0,.89-1.1,2.29,2.29,0,0,0,.38-.49,5.63,5.63,0,0,0,.51-.67,9.77,9.77,0,0,0,.71-1c.14-.18.2-.27.27-.35l.18-.26c.13-.18.24-.36.36-.55l.23-.31a3.62,3.62,0,0,0,.2-.33,3.43,3.43,0,0,0,.39-.6,7.32,7.32,0,0,0,.52-.8,2,2,0,0,0,.16-.24.75.75,0,0,0,.07-.12l.07-.13.17-.24c.16-.25.31-.5.45-.77l.2-.33.63-1.09a1.25,1.25,0,0,0,.21-.35c.16-.26.31-.52.46-.8,0-.09.09-.18.14-.27a2,2,0,0,0,.21-.39l.54-1c.09-.19.19-.37.28-.56a4.83,4.83,0,0,0,.39-.79c.43-.79.81-1.59,1.16-2.41l.16-.37a6.26,6.26,0,0,0,.38-.89,29.54,29.54,0,0,0,1.09-2.81l.09-.24a15,15,0,0,0,.53-1.65c.22-.68.4-1.35.57-2,.06-.22.12-.44.17-.67a.32.32,0,0,0,.06-.22,1.42,1.42,0,0,0,0-.16l.08-.3a19.67,19.67,0,0,0,.58-2.48v-.13a.45.45,0,0,0,0-.22s0-.09,0-.13,0-.16,0-.23a2.11,2.11,0,0,1,0-.25,5.72,5.72,0,0,0,.09-1.07c0-.14,0-.29,0-.44a.63.63,0,0,0,0-.31c0-.05,0-.11,0-.17a2.9,2.9,0,0,0-.16-.92,4.81,4.81,0,0,0-.42-1.28,4.94,4.94,0,0,0-1.08-1.76,1.16,1.16,0,0,0-.51-.42s-.05-.08-.11-.07a.89.89,0,0,0-.58-.18,4.45,4.45,0,0,0-1.84.32l-.21.09a2.26,2.26,0,0,0-.52.2l-.1.06C410.28,82.5,410.13,82.56,410,82.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,138.9a1.26,1.26,0,0,0,.61,1.09l-5.74-3.19h0a1.25,1.25,0,0,1-.63-1.1l0-10.78,5.77-.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.32,86.94l39.53-22.82a1.25,1.25,0,0,1,1.24,0h.05l5.78,3.21h0a1.3,1.3,0,0,0-1.28,0L382.11,90.15A3.87,3.87,0,0,0,380.47,92l-5.74-3.31A3.84,3.84,0,0,1,376.32,86.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43,105l0-14.69a3.83,3.83,0,0,1,.34-1.58L380.47,92a4,4,0,0,0-.29,1.49l0,14.69L374.43,105Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,119.13,374.43,105l5.79,3.22h0l-13.68,14.14c-1.06,1.1-1.3,2.67-.74,3.28l-5.45-3C359.4,122.31,359.53,120.4,360.75,119.13Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.89,59.81h0c-.76-2.88-6.15-8.37-11.51-8.26a4.35,4.35,0,0,0-1.51.33L117.7,116.29a10.5,10.5,0,0,0-4,4.66,11.57,11.57,0,0,0-1,4.76V370.65c0,6.24,6.62,12.19,12.84,9.33,0,0,0,0,0,0a3.52,3.52,0,0,0,.4-.18l104.18-64.53a11,11,0,0,0,5-9.41V61A2.8,2.8,0,0,0,234.89,59.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.2,151.6a5.51,5.51,0,0,1,2.52-4.71l96.73-59.82a2.5,2.5,0,0,1,3.72,2.35V286.94a5.5,5.5,0,0,1-2.52,4.7l-96.73,59.92a2.5,2.5,0,0,1-3.72-2.35Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.66,125.71V370.65c0,6.24,6.62,12.19,12.84,9.33,0,0,0,0,0,0a2.52,2.52,0,0,1-3.33-2.53V132.48a11.5,11.5,0,0,1,1.69-6L113.7,121A11.57,11.57,0,0,0,112.66,125.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,51.54a4.35,4.35,0,0,0-1.51.33L117.7,116.29a10.5,10.5,0,0,0-4,4.66l10.2,5.54a10.27,10.27,0,0,1,3.35-3.43L231.43,58.64a2.39,2.39,0,0,1,3.46,1.17h0C234.14,56.92,228.75,51.43,223.39,51.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52,99.08c.74-.46,1.34-.1,1.34.81a3.26,3.26,0,0,1-1.33,2.51l-20.44,12.83c-.73.46-1.32.07-1.32-.84a3.21,3.21,0,0,1,1.31-2.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,115.2c.73-.46,1.32-.09,1.32.82a3.23,3.23,0,0,1-1.32,2.5c-.73.46-1.33.09-1.34-.83A3.24,3.24,0,0,1,165.84,115.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.92,97.22c1.46-.92,2.64-.19,2.64,1.64a6.48,6.48,0,0,1-2.62,5c-1.47.91-2.68.16-2.68-1.66A6.45,6.45,0,0,1,178.92,97.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,327.81c3-1.87,5.38-.38,5.39,3.34s-2.38,8.29-5.36,10.16-5.44.34-5.45-3.38A13.17,13.17,0,0,1,178.93,327.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,189.86a2.71,2.71,0,0,0-.69.57,2,2,0,0,0-.35.65,32.93,32.93,0,0,0-1.68,4.23c-.5,1.27-1,2.55-1.39,3.83a3,3,0,0,0-.26.73,5.09,5.09,0,0,0-.34,1l-.81,2.14c-.09.21-.19.41-.28.61a12.15,12.15,0,0,0-.66,1.86,1.78,1.78,0,0,0,.17,1.68,5.38,5.38,0,0,0,2.34,1.33l.24.07c.24.08.48.14.72.21l1.26.64.24.17a3.61,3.61,0,0,1,.25.3,1.05,1.05,0,0,1,.19.36,1.39,1.39,0,0,1,0,.65l-.21,1c-.18.54-.37,1.08-.56,1.61l-.27.7c-.28.75-.57,1.51-.86,2.26s-.55,1.36-.78,2a13.21,13.21,0,0,0-.58,1.34c-.1.23-.21.46-.31.68-.27.57-.53,1.14-.79,1.71l-.24.51-.84,1.66c-.1.21-.21.42-.32.63l-1,1.8c-.08.15-.17.3-.26.45-.36.61-.72,1.23-1.09,1.84l-.3.47c-.76,1.15-1.52,2.3-2.29,3.45l-.9,1.27-.25.35-2.79,3.65-.94,1.07a3,3,0,0,1-.71.63,1.08,1.08,0,0,1-1.14.07l-.69-.38c0-.1-.09-.12-.16-.13a20.64,20.64,0,0,0-3.09-2.3,1.24,1.24,0,0,0-1.35,0,2.42,2.42,0,0,0-.35.26,6.9,6.9,0,0,0-1.18,1.37.76.76,0,0,0-.24.35c-.84,1.21-1.76,2.29-2.63,3.45-.81.95-1.61,1.93-2.38,2.95-.44.52-.86,1.05-1.26,1.63a20.93,20.93,0,0,0-1.37,1.81,3.65,3.65,0,0,0-.47.69,2.41,2.41,0,0,0-.55,1.94,6.27,6.27,0,0,0,.1,1.25,5.62,5.62,0,0,0,.32,1.49,3.35,3.35,0,0,0,.28,1,2.44,2.44,0,0,0,.14.28.71.71,0,0,0,.05.22,1.17,1.17,0,0,0,.17.26.89.89,0,0,0,.44.52,1.36,1.36,0,0,0,.54.45,3.2,3.2,0,0,0,.39.16l.26.07a1.79,1.79,0,0,0,.32.13l.15,0a1.55,1.55,0,0,0,.53,0,.24.24,0,0,0,.25,0,1.37,1.37,0,0,0,.67,0,2,2,0,0,0,.73,0,2.38,2.38,0,0,0,.74-.07l.44,0a5.71,5.71,0,0,0,1-.23l.15,0a2.39,2.39,0,0,0,.38-.09.86.86,0,0,0,.24-.11c.29-.09.34-.12.4-.14a8.29,8.29,0,0,0,1.09-.44l.32-.16.23-.14a4.83,4.83,0,0,0,.62-.42l.73-.48a6.26,6.26,0,0,0,.77-.63,6.55,6.55,0,0,0,.7-.51c.09-.07.18-.16.27-.24l.13-.14.38-.33c.38-.35.76-.71,1.12-1.11a6.5,6.5,0,0,0,.83-.83.63.63,0,0,0,.22-.26,17.17,17.17,0,0,0,1.47-1.52,16.29,16.29,0,0,0,1.15-1.19,7.43,7.43,0,0,0,.85-.91l.46-.51a1.56,1.56,0,0,0,.36-.4.49.49,0,0,0,.16-.19,3.31,3.31,0,0,0,.26-.27,3.88,3.88,0,0,0,.4-.49,11.45,11.45,0,0,0,.78-.9l.24-.32.25-.3c.46-.57.92-1.12,1.34-1.75a3.72,3.72,0,0,0,.58-.76,8.21,8.21,0,0,0,.77-1.06,17,17,0,0,0,1.08-1.54c.21-.29.31-.42.4-.56s.2-.27.29-.41.36-.56.53-.85l.35-.49a5.74,5.74,0,0,0,.32-.53,6,6,0,0,0,.59-.94,11.66,11.66,0,0,0,.78-1.27,1.85,1.85,0,0,0,.25-.37l.11-.19a2,2,0,0,0,.1-.21c.09-.12.17-.25.25-.38q.38-.58.69-1.2l.31-.52,1-1.72a2.35,2.35,0,0,0,.31-.56c.25-.4.48-.82.7-1.25l.21-.43a4.14,4.14,0,0,0,.32-.61l.82-1.56c.14-.3.29-.59.43-.88a8.83,8.83,0,0,0,.6-1.24c.65-1.25,1.22-2.52,1.75-3.8l.24-.58a11.52,11.52,0,0,0,.59-1.42c.62-1.46,1.18-2.94,1.65-4.42,0-.13.09-.25.14-.37a21.6,21.6,0,0,0,.79-2.61c.35-1.07.62-2.13.88-3.18.08-.36.17-.71.26-1.06a.71.71,0,0,0,.09-.36c0-.08.05-.16.07-.24l.12-.47a30.87,30.87,0,0,0,.88-3.92l0-.2a.61.61,0,0,0,0-.34l0-.21c0-.12,0-.24.05-.37l0-.38a9,9,0,0,0,.14-1.68c0-.23,0-.47,0-.7a1.29,1.29,0,0,0,0-.49,2.28,2.28,0,0,1,0-.27,4.93,4.93,0,0,0-.25-1.45,7.3,7.3,0,0,0-.64-2,7.92,7.92,0,0,0-1.63-2.78,1.75,1.75,0,0,0-.78-.65c0-.06-.07-.14-.17-.11a1.33,1.33,0,0,0-.88-.29,6.4,6.4,0,0,0-2.79.51l-.32.13a4.18,4.18,0,0,0-.79.32l-.15.1C189.24,189.61,189,189.72,188.76,189.86Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingAmico);
export default __webpack_public_path__ + "static/media/Calling-amico.725d4f10bd7e1687dd9aa7b0fd3311a2.svg";
export { ForwardRef as ReactComponent };